module.exports = "/assets/landing-bfw/how-it-works/arrow@2x.png?a6AGRk2";